import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Stream from './children/stream';

class Streams extends Component {
	componentWillMount() {
		const { match, clearAndGetChannel } = this.props;
		const channelId = get(match, 'params.channelId');
		if (channelId) {
			clearAndGetChannel(channelId);
		}
	}

	renderStreams() {
		const { availableStreams, status } = this.props;
		if (availableStreams && availableStreams.length) {
			return availableStreams.map(stream => (
				<Stream key={`stream-${stream.id}`} stream={stream} />
			));
		}
		if (status === 'initialized') {
			return <div>No public streams could be found...</div>;
		}
		return <div>Loading...</div>;
	}

	render() {
		return (
			<div>
				<span>Streams</span>

				{this.renderStreams()}
			</div>
		);
	}
}

Streams.propTypes = {
	clearAndGetChannel: PropTypes.func.isRequired,
	status: PropTypes.string.isRequired,
};

Streams.defaultProps = {};

export default Streams;



// WEBPACK FOOTER //
// ./src/ui/streams/Streams.component.js